import React from 'react';
import Link from 'next/link';
import styles from 'components/Card/Card.module.css';
import dateInterval, { num_word } from 'utils/dateInterval';
import { Question } from 'types/Questions.types';

////////// TODO:  Заменить кнопку //////////

const Card = ({
  body,
  publishedAnswersCount,
  category,
  grade,
  slug,
  authorAvatar,
  updatedAt,
}: Question) => {
  //Обрезаем текст вопроса после 17 пробела
  const questionText =
    body.split(' ').length > 16 ? body.split(' ', 17).join(' ') + '...' : body;

  return (
    <article className={styles.card} data-qa-marker="qstn_card">
      <div className={styles.card__content}>
        <img alt={'123'} className={styles.card__avatar} src={authorAvatar} />
        <Link href={`/questions/${slug}`}>
          <a className={styles.card__text} data-qa-marker="qstn_card_txt">
            {questionText}
          </a>
        </Link>
        <div className={styles.card__footer}>
          <Link href={`/categories/${category.slug}?klass=${grade}`}>
            <a className={styles.card__attrs}>
              <span className={styles.card__category}>{category.title}</span>
              <span className={styles.card__details}>{grade} класс</span>
              <span className={styles.card__details}>{dateInterval(updatedAt)}</span>
            </a>
          </Link>
          <div className={styles.card__count}>
            <Link href={`/questions/${slug}#questions-page__answers`}>
              <a className={styles.card__counter}>
                {num_word(publishedAnswersCount, ['ответ', 'ответа', 'ответов'])}
              </a>
            </Link>
            <Link href={`/questions/${slug}`}>
              <a className={styles.card__btn}> Ответить </a>
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
};

export default Card;
